module.exports = __webpack_public_path__ + "static/media/HCMM087.8739dd6d.jpg";